import { FR_BIO } from './bio.js';
import { FR_HANDLES } from './handles.js';
import { FR_FEMALE, FR_MALE, FR_SURNAMES } from './names.js';
import type { LocalePack } from '../types.js';

const LIGATURES: Readonly<Record<string, string>> = { œ: 'oe', Œ: 'OE', æ: 'ae', Æ: 'AE', ß: 'ss' };

/** French market vocabulary (BeurteletChatFun). */
export const frPack: LocalePack = {
  locale: 'fr',
  names: { female: FR_FEMALE, male: FR_MALE, surnames: FR_SURNAMES },
  // é è ê ë → e, à â → a, î ï → i, ô → o, ù û ü → u, ç → c, ÿ → y, œ → oe, æ → ae
  asciiFold: (s) =>
    s
      .replace(/[œŒæÆß]/g, (c) => LIGATURES[c] ?? c)
      .normalize('NFD')
      .replace(/\p{M}/gu, ''),
  lower: (s) => s.toLocaleLowerCase('fr-FR'),
  upper: (s) => s.toLocaleUpperCase('fr-FR'),
  handle: FR_HANDLES,
  bio: FR_BIO,
};
